module.exports = new __parcel__URL__("snare_12.7da1f5d8.mp3").toString();